// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.featurelaunch.RentalManagerUserFeatureLaunchWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { AcknowledgeFeatureLaunchNotificationsRequestDto, FeatureLaunchNotificationsResponseWebDto } from '../..';

interface NotificationsParams {
  bypassAcknowledged?: boolean;
}

export const RentalManagerUserFeatureLaunchWebApiHandler_acknowledge_Path =
  '/api/web/v1/users/featureLaunch/acknowledge';

/**
 * Acknowledge feature launch notifications for a user
 */
export const RentalManagerUserFeatureLaunchWebApiHandler_acknowledge = (
  postData: AcknowledgeFeatureLaunchNotificationsRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, AcknowledgeFeatureLaunchNotificationsRequestDto, void>({
    endpoint: RentalManagerUserFeatureLaunchWebApiHandler_acknowledge_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerUserFeatureLaunchWebApiHandler_notifications_Path =
  '/api/web/v1/users/featureLaunch/notifications';

/**
 * Get list of feature launch notifications for a user
 */
export const RentalManagerUserFeatureLaunchWebApiHandler_notifications = (
  getParams: NotificationsParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<NotificationsParams, never, FeatureLaunchNotificationsResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserFeatureLaunchWebApiHandler_notifications_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
